e4.p.card = {
    init: function () {
        e4.p.card.bindEvents();
    },
    bindEvents: function () {
        jQuery( '.js-p-card-link' ).on( 'click', ':not(a[href])', function ( event ) {
            var jCardLink = jQuery( this ).find( 'a[href]' );
            if ( jCardLink.length === 1 && event.target === event.currentTarget && /input|textarea/i.test( event.target.tagName ) === false ) {
                if ( jCardLink.attr( 'target' ) === '_blank' ) {
                    window.open( jCardLink.attr( 'href' ) );
                }
                else {
                    location.href = jCardLink.attr( 'href' );
                }
                jCardLink.triggerHandler( 'click' );
            }
        } );
    }
};

